module.exports = __webpack_public_path__ + "img/word.35075e99.svg";